<template>
  <div class="accreditRegister" style="overflow-y: auto" v-loading="loading">
    <top></top>
    <div class="wBh_container">
      <div class="wBh_Shengming">
        <img
          th:src="../../assets/shouquan_bg.png"
          src="../../assets/shouquan_bg.png"
          class="wBh_ShengmingBg"
        />
        <div class="wBh_sm_Content">
          <img
            th:src="../../assets/left_icon.png"
            src="../../assets/left_icon.png"
            class="disclaimer_LeftPc"
          />
          <img
            th:src="../../assets/right_icon.png"
            src="../../assets/right_icon.png"
            class="disclaimer_RightPc"
          />
          <div class="w_disclaimerLayer clear">
            <div class="disclaimer_Left">
              <h4>
                <img
                  th:src="../../assets/shengming_icon.png"
                  src="../../assets/shengming_icon.png"
                />
                免责声明
              </h4>
              <h5>
                您在接受本网站服务之前，请务必仔细阅读本声明。若您对本声明
                的任何条款有异议，请停止使用本网站所提供的全部服务。
              </h5>
              <p>
                1、本网站提供技术服务，保函服务费由担保机构收取，不介入资金流转，也不承担任何投标人与担保机构之间的纠纷。
              </p>
              <p>
                2、本网站将获取您在交易平台的企业部分信息、投标项目部分信息、历史投标和中标次数记录，用于第三方担保机构审核投标人的申请资格，您已确认将信息授权与本网站，本网站承诺不会将您的信息使用在其他地方。
              </p>
              <p>
                3、电子保函申请有可能审核不通过，由于审核不通过而造成的投标失效本网站不负任何责任，请及时确认好您的项目投标截止日期，以免错过投标机会。
              </p>
              <p>
                4、互联网传输可能会受到干扰，中断、延迟或数据错误，本网站对于非本网站能控制的通讯设施故障可能引致的数据及交易之准确性或及时性不负任何责任。
              </p>
            </div>
            <div class="disclaimer_Right">
              <h4>快速安全登录</h4>
              <img
                th:src="../../assets/logo (1).png"
                src="../../assets/logo (1).png"
              />
              <h5>公航旅电子交易中心平台</h5>
              <h6>
                您的部分项目信息及企业信息将授权于公航旅电子交易中心平台，这些信息将使用于第三方担保机构审核您的申请资格，授权后表明你已同意
              </h6>
              <button type="button" class="authBtn" @click="authlogin">
                授权并登录
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--确认绑定  弹框   开始  -->
    <div class="wBh_PhoneLayer" v-show="ghoneLayer">
      <div class="wBh_PhoneMain">
        <span class="wBh_Close">
          <img
            th:src="../../assets/bh_close.png}"
            src="../../assets/bh_close.png"
            @click="close"
          />
        </span>
        <h5>提示</h5>
        <h6>
          <img
            th:src="../../assets/tishi_icon.png}"
            src="../../assets/tishi_icon.png"
          />
          您的手机号：{{ phone }}
        </h6>
        <h4 class="sq_msg" v-show="!selectBtn">
          已与公航旅电子交易中心平台账号绑定，方便您在公航旅电子交易中心平台查询保函订单请注意查看您的手机短信，便于系统给您发送重要通知。
        </h4>
        <h4 class="selectData" v-show="selectBtn">
          <p>投标登记号: {{ selectData.registerNumber }}</p>
          <p>已选金融机构: {{ selectData.guarantor }}</p>
          <p>{{ selectData.msg }}</p>
        </h4>
        <button @click="sure('0')" v-show="msg_btn" class="btnSure">
          确定
        </button>
        <div class="selectBtn" v-show="selectBtn">
          <button @click="sure()" class="btnSure">重新选择金融机构</button>
          <button @click="sure('1')" class="btnSure">跳转支付界面</button>
        </div>
      </div>
    </div>
    <!--确认绑定  弹框   结束  -->
    <div class="w_Footer">
      <ul>
        <li>Copyright ® 公航旅电子交易中心平台 All right reserved</li>
      </ul>
    </div>
    <!-- 费率通知 -->
    <div class="feedbackdiv" v-show="operationMsg">
      <div class="feedback_content">
        <div class="feedback_title">电子保函申请费率调整通知</div>
        <p style="text-indent: 2em">
          为响应国家《关于深化公共资源交易平台整合共享指导意见》文件要求，
          积极推动推动电子营业执照、电子担保保函在公共资源交易领域的应用，降低企业交易成本，提高交易效率，即日起电子保函申请费率由3%调整为2%。
        </p>
        <!-- <p style="margin-top:30px">运营期间担保机构具体业务开展情况如下：</p>
        <p>甘肃担保：保函申请服务已恢复，审核、出函时间待定</p>
        <p>瀚华担保：保函申请、审核、出函服务已恢复</p> -->
        <p style="margin-top: 75px; text-align: right">
          公航旅电子交易中心平台
        </p>
        <p style="text-align: right">2020年4月20日</p>
        <button type="button" @click="closeMsg">关闭通知页面</button>
      </div>
    </div>

    <!-- 夏河通知 -->
    <div class="feedbackdiv xhmsg" v-show="operationXhMsg">
      <div class="feedback_content">
        <div class="feedback_title">电子保函申请费率调整通知</div>
        <div class="xhmsg-content">
          <p>
            为响应国家《关于深化公共资源交易平台整合共享指导意见》文件要求，进一步帮助企业减负，降低企业交易成本，提高交易效率，经平台与供应商协调沟通，现进行费率调整，调整情况公示如下：
          </p>
          <p>
            甘肃担保保函费率由2%，最低保费限制800元调整为保函费率8‰，最低保费限制300元。
          </p>
          <p>
            此调整于2022年7月1日开始正式执行，请各投标企业合理安排该时间段内的开函事宜。
          </p>
        </div>
        <button type="button" @click="closeMsg">关闭通知页面</button>
      </div>
    </div>

    <!-- 碌曲县通知 -->
    <div class="feedbackdiv xhmsg" v-show="operationLqMsg">
      <div class="feedback_content">
        <div class="feedback_title">电子保函申请费率调整通知</div>
        <div class="xhmsg-content">
          <p>
            为响应国家《关于深化公共资源交易平台整合共享指导意见》文件要求，进一步帮助企业减负，降低企业交易成本，提高交易效率，经平台与供应商协调沟通，现进行费率调整，调整情况公示如下：
          </p>
          <p>
            甘肃担保保函费率由2%，最低保费限制800元调整为保函费率8‰，最低保费限制300元。
          </p>
          <p>
            此调整于2022年7月11日开始正式执行，请各投标企业合理安排该时间段内的开函事宜。
          </p>
        </div>
        <button type="button" @click="closeMsg">关闭通知页面</button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import top from "@/components/Head/Head.vue";
import { accreditLogin } from "@/apis/apis";
export default {
  components: {
    top,
  },
  data() {
    return {
      loading: false,
      operationMsg: false,
      operationXhMsg: false, // 夏河弹窗
      operationLqMsg: false, // 碌曲县弹窗
      phone: "",
      ghoneLayer: false,
      account: "",
      platformCode: "",
      registerNumber: "",
      msg_btn: true,
      newHash: "",
      selectBtn: false,
      selectData: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {},

  methods: {
    // 初始化项目, 根据链接参数设置对应参数
    init() {
      // ==========================先清空所有Storage,以免信息不准==========================
      localStorage.clear();
      sessionStorage.clear();
      // ==========================设置参数==========================
      this.account = this.$route.query.account;
      this.phone = this.account;
      this.mycookie = document.cookie;
      // ==========================判断弹窗显示内容==========================
      this.isOperationMsg();
      // ==========================设置vuex地区, 及是否指定展示担保机构==========================
      this.$store.commit("SET_PLATFORM_CODE", this.$route.query.platformCode);
      this.$store.commit("SET_HTML_TITLE");
      this.$store.commit(
        "SET_DESIGNATED_GUARANTEE_AGENCY",
        this.$route.query.guarator || ""
      );
    },

    // 根据条件展示费率弹窗
    isOperationMsg() {
      // 判断是否为夏河
      if (this.$route.query.platformCode == "FW10005") {
        this.operationXhMsg = true;
        return;
      }

      // 判断是否为碌曲
      if (this.$route.query.platformCode == "FW10021") {
        this.operationLqMsg = true;
        return;
      }

      // 判断是否为收费为3%的地区
      let is3 = ["FW10001", "FW10004", "FW10006", "FW10007", "FW10008"];
      if (is3.includes(this.$route.query.platformCode)) {
        this.operationMsg = true;
        return;
      }
    },

    // 设置授权登陆相关参数=>this.platformCode, this.registerNumber.
    setAccreditLoginParams() {
      var cookieData = this.mycookie.split(";");
      if (this.$route.query.platformCode == undefined) {
        for (let i = 0; i < cookieData.length; i++) {
          var cookieItem = cookieData[i].trim();
          if (
            cookieItem.length > 12 &&
            cookieItem.substr(0, 12) == "platformCode"
          ) {
            this.platformCode = cookieItem.substr(13, cookieItem.length);
          }
        }
      } else {
        this.platformCode = this.$route.query.platformCode;
      }

      // debugger;
      if (this.$route.query.registerNumber == undefined) {
        for (let i = 0; i < cookieData.length; i++) {
          var cookieItem = cookieData[i].trim();
          if (
            cookieItem.length > 14 &&
            cookieItem.substr(0, 14) == "registerNumber"
          ) {
            this.registerNumber = cookieItem.substr(15, cookieItem.length);
          }
        }
      } else {
        this.registerNumber = this.$route.query.registerNumber;
      }
    },

    // 关闭通知页面-按钮
    closeMsg() {
      this.operationMsg = false;
      this.operationXhMsg = false;
      this.operationLqMsg = false;
    },

    // 确认登陆弹框-按钮
    authlogin() {
      this.ghoneLayer = true;
    },

    // 确认登陆弹框 => 确认登陆按钮
    sure(flag) {
      // 设置授权登陆相关参数=>this.platformCode, this.registerNumber.
      this.setAccreditLoginParams();
      this.loading = true;
      const companyName = "天台县基础设施投资有限公司电子招投标交易平台";
      // 授权登陆接口
      accreditLogin(
        this.account,
        companyName,
        this.platformCode,
        this.registerNumber,
        flag
      )
        .then((res) => {
          // 已经申请并支付成功, 可跳转到首页
          if ([-16, -17].includes(res.data.status)) {
            sessionStorage.setItem("accreditStatus", res.data.status);
            sessionStorage.setItem("payUrl", res.data.data.src || "");
            this.toHome(res, "2");
          }
          if (res.data.data && res.data.data.isOrNoCommit === "1") {
            this.loading = false;
            window.open(res.data.data.src, "_blank");
            return;
          } else if (res.data.data && res.data.data.isOrNoCommit === "0") {
            this.loading = false;
            this.selectBtn = true;
            this.msg_btn = false;
            $(".sq_msg").html(res.data.data.msg);
            this.selectData = {
              guarantor: res.data.data.guarantor,
              registerNumber: res.data.data.registerNumber,
              msg: res.data.data.msg,
            };
            return;
          }
          if (res.data.status == "1") {
            this.toHome(res, "1");
          } else {
            $(".sq_msg").html(res.data.msg);
            this.msg_btn = false;
            this.selectBtn = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toHome(res, accredit) {
      this.msg_btn = true;
      this.ghoneLayer = false;
      this.$store.commit("SET_CORPORATE_NAME", res.data.data.applyUser);

      sessionStorage.setItem("sq_applyUser", res.data.data.applyUser);
      sessionStorage.setItem(
        "getCompanyname",
        res.data.data.tradingPlatformName
      );
      sessionStorage.setItem("sq_marginAmount", res.data.data.marginAmount);
      sessionStorage.setItem(
        "sq_projectTenderer",
        res.data.data.projectTenderer
      );
      sessionStorage.setItem("sq_registerNumber", res.data.data.registerNumber);
      sessionStorage.setItem(
        "uniformCreditCode",
        res.data.data.uniformCreditCode
      );
      sessionStorage.setItem("tokenId2", res.data.msg);

      this.$store.state.tokenId = res.data.msg;
      // 设置UUID
      sessionStorage.setItem("uuid", res.data.data.uuid || "");

      sessionStorage.setItem("accredit", accredit);
      sessionStorage.setItem("accreditPhone", this.phone);
      var newPlatformCode = this.platformCode;
      sessionStorage.setItem("newPlatformCode", newPlatformCode);

      this.$router.push("/");
    },
    // 确认登陆弹框 => 关闭弹框, 初始化显示内容
    close() {
      this.ghoneLayer = false;
      this.msg_btn = true;
      this.selectBtn = false;
    },
  },
};
</script>

<style lang="less" scoped>
.accreditRegister .wBh_PhoneLayer .wBh_PhoneMain {
  .selectData {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.4;
    padding: 18px 100px;
  }
  .selectBtn {
    display: flex;
  }
}
.feedbackdiv {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  outline: 0;
  -webkit-overflow-scrolling: touch;
  background-color: #a6abaf;
  filter: alpha(opacity=60);
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9998;
  .feedback_content {
    border: 1px solid #ccc;
    position: absolute;
    width: 438px;
    height: 476px;
    border: 0px;
    top: 50%;
    left: 50%;
    margin-top: -247px;
    margin-left: -238px;
    background-color: #fff;
    z-index: 9999;
    .feedback_title {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      line-height: 80px;
      margin-top: 30px;
      color: #333333;
    }
    p {
      padding: 0px 50px;
      font-size: 13px;
      line-height: 23px;
      font-weight: 550;
      color: #333333;
      text-indent: 2em;
    }
    button {
      border: none;
      width: 250px;
      height: 40px;
      color: #fff;
      background: #1aaecf;
      margin-top: 42px;
      margin-left: 93px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .xhmsg {
    &-content {
      font-weight: bold;
      p {
        line-height: 1.4;
        text-indent: 2em;
        &:not(last-child) {
          margin-bottom: 20px;
        }
      }
    }
  }
}
/deep/ .top-box {
  margin-bottom: 0px;
}
/deep/ .top-rightimg {
  display: none;
}
.accreditRegister {
  overflow: hidden;
  position: relative;
  .wBh_container {
    background: #f6f8f9;
    position: relative;
    overflow: hidden;
    .wBh_Shengming {
      width: 100%;
      position: relative;
      overflow: hidden;
      img.wBh_ShengmingBg {
        display: block;
        border: none;
        width: 100%;
        margin-top: -35px;
        height: 850px;
      }
      .wBh_sm_Content {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 1200px;
        height: 700px;
        top: 60px;
        left: 50%;
        margin-left: -600px;
        background-color: rgba(255, 255, 255, 0.72);
        .disclaimer_LeftPc {
          position: absolute;
          width: 58px;
          top: 60px;
          left: 63px;
        }

        .disclaimer_RightPc {
          position: absolute;
          width: 58px;
          bottom: 60px;
          right: 63px;
        }
        .w_disclaimerLayer {
          padding: 168px 0px 0px 126px;

          .disclaimer_Left,
          .disclaimer_Right {
            float: left;
          }
          .disclaimer_Left {
            width: 404px;
            padding-right: 70px;
            border-right: 1px solid #f2f2f2;
            h4 {
              font-size: 20px;
              color: #333;
              height: 20px;
              line-height: 20px;
              margin-bottom: 15px;
              font-weight: 500;
              img {
                display: block;
                border: none;
                width: 24px;
                margin-right: 8px;
                float: left;
              }
            }
            h5 {
              color: #333;
              font-size: 14px;
              margin-bottom: 18px;
              font-weight: 500;
            }
            p {
              color: #666666;
              font-size: 14px;
              margin-bottom: 15px;
            }
          }
          .disclaimer_Right {
            width: 350px;
            padding-left: 70px;
            h4 {
              font-size: 22px;
              color: #333;
              height: 22px;
              line-height: 22px;
              font-weight: 500;
              margin: 10px 0px 25px 0px;
              text-align: center;
            }
            img {
              display: block;
              border: none;
              width: 90px;
              height: 90px;
              margin: 0px auto 15px;
            }
            h5 {
              color: #333;
              font-size: 14px;
              margin-bottom: 18px;
              font-weight: 500;
              text-align: center;
            }
            h6 {
              color: #333;
              font-size: 14px;
              margin-bottom: 30px;
              font-weight: 500;
              a {
                text-decoration: none;
                color: #1aaecf;
                cursor: pointer;
              }
            }
            button {
              border: none;
              outline: none;
              font-family: "微软雅黑";
              font-size: 14px;
              letter-spacing: 0.6px;
              cursor: pointer;
              width: 100%;
              background: #1aaecf;
              height: 50px;
              line-height: 50px;
              color: #fff;
              border-radius: 4px;
            }
          }
        }
      }
    }
  }
  // 弹框
  .wBh_PhoneLayer {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.2);
    .wBh_PhoneMain {
      width: 460px;
      padding: 0 0 20px;
      // height: 286px;
      background: #fff;
      border-radius: 3px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -230px;
      margin-top: -143px;
      overflow: hidden;
      text-align: center;
      .wBh_Close {
        display: block;
        width: 40px;
        height: 34px;
        background: #eee;
        position: absolute;
        right: 0px;
        top: 0px;
        cursor: pointer;
        img {
          display: block;
          border: none;
        }
      }
      .wBh_Close:hover {
        opacity: 0.85;
      }
      h4 {
        padding-top: 18px;
        padding-bottom: 45px;
        border-bottom: 1px solid #f5f5f5;
        text-align: left;
        margin-bottom: 18px;
      }
      h5 {
        font-size: 16px;
        padding-top: 35px;
        padding-bottom: 45px;
        letter-spacing: 1px;
      }
      h6 {
        font-size: 16px;
        color: #ed9b0c;
        img {
          display: inline-block;
          *display: inline;
          *zoom: 1;
          vertical-align: top;
          margin: -2px 8px 0px 0px;
        }
      }
      button {
        border: none;
        outline: none;
        font-family: "微软雅黑";
        font-size: 14px;
        letter-spacing: 0.6px;
        cursor: pointer;
        display: inline-block;
        *display: inline;
        *zoom: 1;
        width: 140px;
        text-align: center;
        line-height: 40px;
        height: 40px;
        background: #1aaecf;
        border-radius: 3px;
        margin: auto;
        color: #fff;
      }
      button:hover {
        opacity: 0.85;
      }
    }
    .wBh_PhoneMain h4,
    .wBh_PhoneMain h5,
    .wBh_PhoneMain h6 {
      font-size: 14px;
      color: #666;
      font-weight: 500;
      text-align: center;
      padding-left: 54px;
      padding-right: 54px;
      line-height: 16px;
    }
  }
  .w_Footer {
    width: 100%;
    padding: 30px 0px;
    background: #333333;
    ul {
      li {
        width: 100%;
        text-align: center;
        color: #999;
        margin-top: 6px;
      }
      li:first-child {
        margin-top: 0px;
      }
    }
  }
}
</style>
